export default __webpack_public_path__ + "media/src/features/footer/assets/facebook-15e8a7e3163b205e74011b7c351af68f.png";